import React from 'react';
import FamilyCatalog from './FamilyCatalog';
import './AppsPage.css';

export default function LegacyAppsContent({ catalog, organizationName }) {
  const launchUrl = process.env.REACT_APP_OURMEMORIES_LAUNCH_URL ||
    'http://127.0.0.1:5173/auth/everyid/start';
  // Compatibility rendering uses the same product metadata as the managed path.
  // This external action remains exclusive to the existing flag-off launcher.
  const apps = catalog.filter(app => app.legacyPresentation).map(app => ({ ...app,
    state: app.legacyPresentation === 'external' ? 'open' : 'coming_soon' }));
  return <main className="apps-page">
    <FamilyCatalog apps={apps} organizationName={organizationName} renderCard={app => <article className="app-card" aria-label={app.displayName}>
      <h2>{app.displayName}</h2><p>{app.description}</p>
      <div className="app-card-footer">
        <span className="app-card-status app-card-status-muted">
          {app.state === 'open' ? 'External app' : 'Coming soon'}
        </span>
        {app.state === 'open' && app.appKey === 'ourmemories' && <button type="button"
          className="app-primary-button" onClick={() => window.location.assign(launchUrl)}>Create a Memory</button>}
      </div>
    </article>} />
  </main>;
}
